import { Form } from '../../services/form';
import { ImageModel } from '../../models/image.model';
import { Router } from '@angular/router';
import { AddressModel } from '../../models/address.model';

import { UserModel } from '../../models/user.model';
import { NotificationService } from '../../notification/swal/notification.service';
import { AuthService } from '../../services/auth.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import Auth from '../../helpers/auth';
import { MaskHelper } from '../../helpers/mask';
import { CropperSettings, ImageCropperComponent, Bounds } from 'ng2-img-cropper';
import { ImageService } from '../../services/image.service';
import { BuscaCepService } from '../../services/busca-cep.service';
import { InputModel } from '../input/input.model';
import { StringUtils } from '../../helpers/stringUtils';
import { DeleteAccountService } from '../../services/deleteAccount.service';

@Component({
  selector: 'app-account',
  templateUrl: './account.component.html',
  styleUrls: ['./account.component.less']
})

export class AccountComponent extends Form implements OnInit {

  private initialCEP;
  @ViewChild('cropper', undefined)

  cropper: ImageCropperComponent;
  cropperSettings: CropperSettings = new CropperSettings();
  data = {
    image: ''
  };

  user: UserModel = new UserModel();
  tempCpf: string;

  constructor(private router: Router, private authService: AuthService, private imageService: ImageService,
    private notificationService: NotificationService, private buscaCepService: BuscaCepService, private deleteAccountService: DeleteAccountService) {
      super();
  }

  deleteAccount() {
    this.notificationService.showQuestionNotification('Tem certeza que deseja excluir sua conta?')
      .then(result => {
        if (result.value) {
          this.deleteAccountService.removeAccount()
            .then(() => {
              this.notificationService.showSuccessNotification('Conta excluída com sucesso!');
              localStorage.clear();
              this.router.navigate(['/login']);
            });
        }
      });
  }

  updateImage(imageBase64, fileName) {
    const image = new ImageModel();
    image.imageData = imageBase64.split('base64,')[1];
    image.fileName = fileName;
    this.imageService.updateUser(Auth.getUser().id, image)
      .then(() => {
        this.notificationService.showSuccessNotification('Foto alterada com sucesso!');
      })
      .catch((err) => {
        this.notificationService.showErrorNotification(err.message);
      });
  }

  fileChangeListener($event) {
    const image: any = new Image();
    const file: File = $event.target.files[0];
    const myReader: FileReader = new FileReader();
    const that = this;
    myReader.onloadend = function (loadEvent: any) {
      image.src = loadEvent.target.result;
      that.cropper.setImage(image);
      that.updateImage(image.src, file.name);
    };
    myReader.readAsDataURL(file);
  }

  ngOnInit() {
    if (!StringUtils.isCPF(Auth.getUser().cpf)) {
      this.user.documentInputModel = new InputModel(false, false, 'tel', 'Passaporte / Documento', [], null, 11);
      this.user.documentInputModel.setReadOnly();
    }

    this.user.id = Auth.getUser().id;
    this.user.nome = Auth.getUser().nome;
    this.user.foto = Auth.getUser().foto;
    this.tempCpf = Auth.getUser().cpf;
    this.user.cpf = Auth.getUser().cpf;
    this.user.endereco.logradouro = Auth.getUser().endereco ? Auth.getUser().endereco.logradouro : '';
    this.user.endereco.numero = Auth.getUser().endereco ? Auth.getUser().endereco.numero : '';
    this.user.endereco.complemento = Auth.getUser().endereco ? Auth.getUser().endereco.complemento : '';
    this.user.endereco.bairro = Auth.getUser().endereco ? Auth.getUser().endereco.bairro : '';
    this.user.endereco.cidadeNome = Auth.getUser().endereco ? Auth.getUser().endereco.cidadeNome : '';
    this.user.endereco.CEP = Auth.getUser().endereco ? Auth.getUser().endereco.CEP : '';
    this.user.endereco.estadoUF = Auth.getUser().endereco ? Auth.getUser().endereco.estadoUF : '';
    this.user.endereco.cidadeId = Auth.getUser().endereco ? Auth.getUser().endereco.cidadeId : '';
    this.user.RG = Auth.getUser().RG;
    this.user.codigoUnico = Auth.getUser().codigoUnico;
    this.user.sexo = Auth.getUser().sexo;
    this.user.ddd = Auth.getUser().ddd;
    this.user.dataCriacao = Auth.getUser().dataCriacao;
    this.user.dataNascimento = Auth.getUser().dataNascimento;
    this.user.facebookId = Auth.getUser().facebookId;
    this.user.pin = Auth.getUser().pin;
    this.user.pinBloqueado = Auth.getUser().pinBloqueado;
    this.user.email = Auth.getUser().email;
    this.user.password = Auth.getUser().password;
    this.user.telefone = Auth.getUser().telefone;
    this.initialCEP = this.user.endereco.CEP;

    if (this.user.endereco === null) {
      this.user.endereco = new AddressModel();
    }
    this.findImage(this.user.foto.url);
    this.user.checkIfStillReadOnly();
  }

  findImage(url) {
    this.imageService.findImage(url)
      .then(() => {
        this.data = {
          image: this.user.foto.url
        };
      })
      .catch(() => {
        this.data = {
          image: '../../../assets/images/account-shadow.jpg'
        };
      });
  }

  private updateValidFields() {
    this.user = MaskHelper.removeUserMask(this.user);
    this.authService.update(this.user)
      .then(() => {
        this.notificationService.showSuccessNotification('Alterado com sucesso!');
      })
      .catch((err) => {
        this.notificationService.showErrorNotification(err.message);
      });
  }

  update() {
    if (this.getFormStatus()) {
      this.updateValidFields();
    } else {
      this.notificationService.showErrorNotification('Todos os campos precisam estar válidos!');
    }
  }

  changePassword() {
    this.router.navigate([`general/alterarSenha/user/${this.user.id}/${this.user.id}`]);
  }

  buscaCep() {
    if (this.user.endereco.CEP === this.initialCEP) {
      return;
    }

    if (this.user.endereco.CEP.length !== 9) {
      this.notificationService.showAlertNotification('O CEP deve conter 8 dígitos');
      this.initialCEP = this.user.endereco.CEP = '';
      this.fillFields('');
      return;
    }

    this.buscaCepService.getByCep(this.user.endereco.CEP).then((response: any) => {
      if (response.erro) {
        this.cepNotFound();
        this.initialCEP = this.user.endereco.CEP;
      }
      this.fillFields(response);

    }).catch(() => {
      this.cepNotFound();
    });
  }

  private fillFields(response: any) {
    this.user.endereco.logradouro = response.logradouro;
    this.user.endereco.numero = '';
    this.user.endereco.complemento = '';
    this.user.endereco.bairro = response.bairro;
    this.user.endereco.cidadeNome = response.localidade;
    this.user.endereco.estadoUF = response.uf;
  }

  private cepNotFound() {
    this.notificationService.showAlertNotification('CEP não encontrado.');
  }
}




// WEBPACK FOOTER //
// /usr/src/app/src/app/components/account/account.component.ts